import React from 'react';
import { Coffee, Compass, Home, Leaf } from 'lucide-react';
import { experiences } from '../data/site';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
const iconMap = {
  home: Home,
  coffee: Coffee,
  leaf: Leaf,
  compass: Compass
};
export function Experience() {
  return <section className="w-full bg-sand-light py-24 sm:py-28 lg:py-36" data-id="element-56" data-mp="1tvhabp7t4d27">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12" data-id="element-57" data-mp="2rhwpulgob0n4">
        <Reveal className="max-w-2xl" data-id="element-58" data-mp="2rg3tbyzrxwsu">
          <SectionLabel data-id="element-59" data-mp="2mik82f4nsjre">What to expect</SectionLabel>
          <h2 className="mt-6 font-serif text-[clamp(2rem,4.5vw,3.5rem)] font-light leading-[1.08] text-forest-deep" data-id="element-60" data-mp="2mh0oofnphsle">
            The Taveuni experience
          </h2>
          <p className="mt-5 text-[16px] leading-relaxed text-forest-deep/65" data-id="element-61" data-mp="2cjw3ai1oq15n">
            Everything you need for a comfortable and memorable stay.
          </p>
        </Reveal>

        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:mt-20 lg:grid-cols-4" data-id="element-62" data-mp="115heefvaaabh">
          {experiences.map((item, i) => {
          const Icon = iconMap[item.icon];
          return <Reveal as="li" key={item.title} delay={i * 0.08} data-id="element-63" data-mp="yovtklwbad23" data-mpi={i}>
                <article className="group h-full rounded-[1.75rem] bg-ivory p-8 transition-all duration-500 ease-calm hover:-translate-y-1.5 hover:shadow-soft" data-id="element-64" data-mp="ylzx72043wfr">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-gold/45 text-ocean transition-colors duration-500 group-hover:bg-ocean group-hover:text-ivory" data-id="element-65" data-mp="oov6covbncsm">
                    <Icon className="h-5 w-5" strokeWidth={1.4} aria-hidden="true" data-id="element-66" data-mp="fr1bzjh4at83" />
                  </span>
                  <h3 className="mt-7 text-[12px] font-semibold uppercase tracking-[0.16em] text-forest-deep" data-id="element-67" data-mp="12ey7m7529iz">
                    {item.title}
                  </h3>
                  <p className="mt-3.5 text-[15px] leading-[1.75] text-forest-deep/65" data-id="element-68" data-mp="3o6cogfijom6o">
                    {item.description}
                  </p>
                </article>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}